// ============================================================
// ModalPerfilIncompleto
// ------------------------------------------------------------
// Modal bloqueante que se muestra cuando el médico intenta
// iniciar una consulta sin tener el perfil completo.
//
// NOTA: cuando agregues el switch NOM-024, condicionas
// la aparición de este modal a que el switch esté prendido.
// ============================================================

import React from "react";
import { useNavigate } from "react-router-dom";
import "./ModalEdicion.css";

const ModalPerfilIncompleto = ({ faltantes }) => {
  const navigate = useNavigate();

  if (!faltantes || faltantes.length === 0) return null;

  return (
    <div className="modal-overlay modal-perfil-overlay">
      <div className="modal-content modal-perfil">
        <h3>⚠️ Perfil incompleto</h3>
        <h5>Considera que estos datos ya no se podrán mover una vez guardada la primer consulta</h5>
        <p>Antes de iniciar una consulta debes completar estos datos en tu perfil:</p>
        <ul className="modal-perfil-lista">
          {faltantes.map((campo, i) => (
            <li key={i}>❌ {campo}</li>
          ))}
        </ul>
        <div className="modal-buttons">
          <button
            className="btn-guardar"
            onClick={() => navigate("/dashboard/configuracion/perfil")}
          >
            Completar mi perfil
          </button>
          <button
            className="btn-cancelar"
            onClick={() => navigate(-1)}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalPerfilIncompleto;